export default "__VITE_ASSET__DmIffnVm__"